(function () {
  var context = window.QidiBreadcrumbContext || {};
  var collectionHandle = context.collectionHandle;
  var readyFlag = 'qidiBreadcrumbContextReady';
  var productLinkSelector = [
    '.boost-sd__product-item a[href*="/products/"]',
    '.boost-sd__product-link[href*="/products/"]',
    '.boost-sd__product-title[href*="/products/"]',
    '.boost-sd__product-image[href*="/products/"]',
    '.boost-sd__product-list a[href*="/products/"]',
    '.boost-sd__collection-product-list a[href*="/products/"]',
    '[data-boost-sd] a[href*="/products/"]'
  ].join(',');

  if (!collectionHandle || document.documentElement.dataset[readyFlag] === 'true') {
    return;
  }

  document.documentElement.dataset[readyFlag] = 'true';

  function isSameStoreProductLink(anchor) {
    if (!anchor || !anchor.href) {
      return false;
    }

    try {
      var url = new URL(anchor.href, window.location.origin);

      return (
        url.origin === window.location.origin &&
        url.pathname.indexOf('/products/') !== -1 &&
        !url.searchParams.has('from_collection')
      );
    } catch (error) {
      return false;
    }
  }

  function patchProductLink(anchor) {
    if (!isSameStoreProductLink(anchor)) {
      return;
    }

    var url = new URL(anchor.href, window.location.origin);
    url.searchParams.set('from_collection', collectionHandle);
    anchor.href = url.pathname + url.search + url.hash;
  }

  function patchProductLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches(productLinkSelector)) {
      patchProductLink(scope);
    }

    scope.querySelectorAll(productLinkSelector).forEach(patchProductLink);
  }

  function schedulePatch(root) {
    window.requestAnimationFrame(function () {
      patchProductLinks(root || document);
    });
  }

  schedulePatch(document);

  document.addEventListener('DOMContentLoaded', function () {
    schedulePatch(document);
  });

  window.addEventListener('pageshow', function () {
    schedulePatch(document);
  });

  function patchClosestProductLink(event) {
    var target = event.target;

    if (!target || !target.closest) {
      return;
    }

    var anchor = target.closest(productLinkSelector);

    if (anchor) {
      patchProductLink(anchor);
      return;
    }

    var productItem = target.closest('.boost-sd__product-item');

    if (productItem) {
      patchProductLinks(productItem);
    }
  }

  ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (eventName) {
    document.addEventListener(eventName, patchClosestProductLink, true);
  });

  document.addEventListener(
    'auxclick',
    function (event) {
      var anchor = event.target.closest && event.target.closest(productLinkSelector);

      if (anchor) {
        patchProductLink(anchor);
      }
    },
    true
  );

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        schedulePatch(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          schedulePatch(node);
        }
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href']
  });
})();
